module.exports = __webpack_public_path__ + "img/physio_activity_4_1.2fb74947.jpg";